import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Category'],
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (page = 1) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/category',
          method: 'GET',
          params: { page, 'access-token': token },
        };
      },
      providesTags: ['Category'],
    }),
    addCategory: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/add-category',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Category'],
    }),
    updateCategory: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/update-category',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Category'],
    }),
    deleteCategory: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/delete-category',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Category'],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
